import axios from '../axios'
import configurations from '../configurations'

const defaultSession = {
  name: null,
  roles: [],
  machine_id: 'A10'
}

const auth = {
  namespaced: true,
  state: {
    data: {},
    username: '',
    error: null,
    loading: false,
    session: defaultSession
  },
  getters: {
    hasMachineId: function (state, getters, rootState, rootGetters) {
      return state.session.machine_id
    },
    hasName: function (state, getters, rootState, rootGetters) {
      return state.session.name
    },
    hasRole: function (state, getters, rootState, rootGetters) {
      return role => {
        return (
          state.session.roles.indexOf('_admin') > -1 ||
          state.session.roles.indexOf(role) > -1
        )
      }
    },
    hasLicenseAdminRole: function (state, getters, rootState, rootGetters) {
      return (state.session.roles.indexOf('trading_admin') > -1 ||
        state.session.roles.indexOf('misb_superuser') > -1)
    },
    hasSession: function (state, getters, rootState, rootGetters) {
      return state.session.name && state.session.name.length > 0
    },
    isLoading: function (state, getters, rootState, rootGetters) {
      return state.loading
    }
  },
  mutations: {
    setData: function (state, payload = { data: {} }) {
      state.data = payload.data
    },
    setError: function (state, payload = { error: null }) {
      state.error = payload.error
    },
    setLoading: function (state, payload = { loading: false }) {
      state.loading = payload.loading
    },
    setSession: function (state, payload = { session: defaultSession }) {
      state.session = payload.session
      state.username = payload.session.name
    }
  },
  actions: {
    logIn: async function (context, payload = {}) {
      context.commit('setLoading', { loading: true })
      try {
        const response = await axios.post('/_session', payload, {
          withCredentials: true
        })
        context.commit('setSession', { session: response.data })
        context.commit('setError', { error: null })
        return response.data
      } catch (error) {
        context.commit('setError', { error })
        return { error: error.message }
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    logOut: async function (context, payload = {}) {
      context.commit('setLoading', { loading: true })
      try {
        const response = await axios.delete('/_session', {
          withCredentials: true
        })
        context.commit('setSession', { session: defaultSession })
        context.commit('setError', { error: null })
        return response.data
      } catch (error) {
        context.commit('setError', { error })
        throw error
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    session: async function (context, payload = {}) {
      context.commit('setLoading', { loading: true })
      try {
        const response = await axios.get('/_session', { withCredentials: true })
        if (
          response.data.userCtx.name !== null &&
          response.data.userCtx.name !== 'couchdb@menggaris.com'
        ) {
          const user = await axios.post(
            configurations.WORKER + '/userInfo',
            { email: response.data.userCtx.name },
            { baseURL: configurations.WORKER, withCredentials: false }
          )
          response.data.userCtx.phone = user.data.phone
          response.data.userCtx.machine_id = user.data.machine_id
          response.data.userCtx.full_name = user.data.full_name
          response.data.userCtx.ic_num = user.data.ic_num
          context.commit('setSession', { session: response.data.userCtx })
          context.commit('setData', { data: user.data })
          context.commit('setError', { error: null })
        }
        return response.data
      } catch (error) {
        context.commit('setError', { error })
        throw error
      } finally {
        context.commit('setLoading', { loading: false })
      }
    }
  }
}

export default auth
